<div class="filter-label">
    <label title="{{props['fieldDescription']}}" class="field-label mt-2 {{ getStatus() }} {{ getFilterFontStatus() }}" *ngIf="props.label" [attr.id]="id + '-label'" (click)="conmuteHide()">
    {{ props.label }}
  </label>
</div>

<div *ngIf="!this.hide">
    <div *ngFor="let field of field.fieldGroup; let i = index">
        <div>
            <formly-field [field]="field" ></formly-field>
        </div>
    </div>
</div>